import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { createDataTestId } from '../../utils';
import { UnorderedListWrapper } from './UnorderedList.style';
import { UnorderedListItem } from './UnorderedListItem';
const renderListItems = _ref => {
  let {
    spacing,
    children,
    lineHeight
  } = _ref;
  return React.Children.map(children, child => {
    const isValidReactElement = React.isValidElement(child);
    if (isValidReactElement) {
      const ListItem = child;
      return React.cloneElement(ListItem, {
        spacing: spacing,
        lineHeight: lineHeight
      });
    }
    return null;
  });
};
export function UnorderedList(_ref2) {
  let {
    spacing,
    children,
    testId,
    lineHeight
  } = _ref2;
  return React.createElement(UnorderedListWrapper, _extends({}, createDataTestId(testId), {
    "data-component": "UnorderedList"
  }), renderListItems({
    spacing,
    children,
    lineHeight
  }));
}
UnorderedList.Item = UnorderedListItem;